if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

onSubmitHandler(evt) {
  evt.preventDefault();
  if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

  this.handleErrorMessage();

  // VALIDARE: Verifică dacă există mesaj de felicitare dar nu e selectată o felicitare
  const greetingMessage = document.getElementById('mesaj-felicitare')?.value?.trim();
  const selectedGreetingCard = window.greetingCardsCarousel?.getSelectedCard();
  
  if (greetingMessage && !selectedGreetingCard) {
    alert('Te rugăm să selectezi o felicitare din carousel!');
    return;
  }

  this.submitButton.setAttribute('aria-disabled', true);
  this.submitButton.classList.add('loading');
  this.querySelector('.loading__spinner').classList.remove('hidden');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData(this.form);
  
  // Generează un ID unic pentru această comandă (timestamp + random)
  const orderItemId = Date.now() + '-' + Math.random().toString(36).substr(2, 9);
  
  // Adaugă ID-ul la floare ca proprietate ascunsă (cu _ la început)
  if (greetingMessage && selectedGreetingCard) {
    formData.append('properties[_order_item_id]', orderItemId);
  }
  
  if (this.cart) {
    formData.append(
      'sections',
      this.cart.getSectionsToRender().map((section) => section.id)
    );
    formData.append('sections_url', window.location.pathname);
    this.cart.setActiveElement(document.activeElement);
  }
  config.body = formData;

  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then(async (response) => {
      if (response.status) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          errors: response.errors || response.description,
          message: response.message,
        });
        this.handleErrorMessage(response.description);

        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
        if (!soldOutMessage) return;
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButtonText.classList.add('hidden');
        soldOutMessage.classList.remove('hidden');
        this.error = true;
        return;
      }

      // ADAUGĂ felicitarea ca produs separat cu același ID
      if (selectedGreetingCard && greetingMessage) {
        try {
          const greetingFormData = new FormData();
          greetingFormData.append('id', selectedGreetingCard.variantId);
          greetingFormData.append('quantity', 1);
          greetingFormData.append('properties[Mesaj Felicitare]', greetingMessage);
          greetingFormData.append('properties[Pentru]', this.querySelector('[name="product-id"]')?.value || 'Produs');
          greetingFormData.append('properties[_order_item_id]', orderItemId); // Același ID ca la floare!

          const greetingConfig = fetchConfig('javascript');
          greetingConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete greetingConfig.headers['Content-Type'];
          greetingConfig.body = greetingFormData;

          const greetingResponse = await fetch(`${routes.cart_add_url}`, greetingConfig);
          const greetingData = await greetingResponse.json();
          
          console.log('Greeting card added:', greetingData);
        } catch (error) {
          console.error('Error adding greeting card:', error);
        }
      }

      // Redirect sau cart drawer
      if (!this.cart) {
        window.location = window.routes.cart_url;
        return;
      }

      if (!this.error)
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: formData.get('id'),
          cartData: response,
        });
      this.error = false;
      const quickAddModal = this.closest('quick-add-modal');
      if (quickAddModal) {
        document.body.addEventListener(
          'modalClosed',
          () => {
            setTimeout(() => {
              this.cart.renderContents(response);
            });
          },
          { once: true }
        );
        quickAddModal.hide(true);
      } else {
        this.cart.renderContents(response);
      }
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      this.submitButton.classList.remove('loading');
      if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      this.querySelector('.loading__spinner').classList.add('hidden');
    });
}

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
